<template>
	<div class="intergral-container">
		<div class="title">
			我的积分
			<el-button class="rulesBtn" type="text" icon="el-icon-question"
				@click="dialogIntergralRulesViable = true">积分获取规则</el-button>
		</div>
		<div class="intergralBox">
			<div class="intergralBoxLeft">
				<div class="intergralTotal">
					<span class="intergralTotalTitle">剩余积分总额：</span>
					{{userInfo.score ? userInfo.score : '0'}}
				</div>
				<div class="intergralTotal" style="color: #333333;">
					<span class="intergralTotalTitle">累计获取积分总额：</span>
					{{userInfo.lj_score ? userInfo.lj_score : '0'}}
				</div>
			</div>
			<div class="record" @click="dialogRecordViable = true">积分明细</div>
		</div>
		<div class="intergralChangeBox">
			积分兑换
		</div>
		<div class="menuBox">
			<div class="naviBox">
				<div class="naviItem" :class="catType == item.value ? 'active' : 'normal'"
					v-for="(item,index) in naviData" :key="index" @click="changeTimeWhere(item)">
					{{item.title}}
				</div>
			</div>
			<div class="menu">
				<div class="menuItem" @click="changeSort('0')">
					默认
					<img src="../assets/Personal/iconL.png" />
				</div>
				<div class="menuItem" @click="changeSort('1')">
					兑换积分
					<img src="../assets/Personal/iconK.png" v-if="px_price == 1" />
					<img src="../assets/Personal/iconJ.png" v-if="px_price == 2" />
					<img src="../assets/Personal/iconQ.png" v-if="px_price == 0" />
				</div>
				<div class="menuItem" @click="changeSort('2')">
					兑换数量
					<img src="../assets/Personal/iconK.png" v-if="px_buy == 2" />
					<img src="../assets/Personal/iconJ.png" v-if="px_buy == 1" />
					<img src="../assets/Personal/iconQ.png" v-if="px_buy == 0" />
				</div>
			</div>
		</div>
		<div class="intergralGoodsList">
			<div class="intergralGoods" v-for="(item,index) in integralData" :key="index"
				@click="changeToDetails(item)">
				<img class="goodsImg" :src="item.img" />
				<div class="goodsTitle ellipsis-1">
					{{item.title}}
				</div>
				<div class="intergralNum">
					<div class="intergral">{{item.price}}积分</div>
					<div class="num">已兑 {{item.buy_count ? item.buy_count : 0}}</div>
				</div>
				<div class="exchange">立即兑换</div>
			</div>
		</div>
		<PagePagination style="padding: .32rem 0 0rem;" :pageSize="12" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<el-dialog class="reportDialog" :visible.sync="dialogIntergralRulesViable" append-to-body
			@close="dialogIntergralRulesViable = false">
			<div slot="title">
				<div class="dislogTitle">
					积分兑换规则
				</div>
			</div>
			<div class="dislogConent">
				<div>1.积分不可进行提现、转账或交易，仅限在本平台内使用。</div>
				<div>2.积分目前通过平台订单消费后，根据平台奖励比例获取。</div>
				<div>3.若用户存在违规行为（如刷分、抄袭作品等），平台有权扣除违规所得积分，并视情节严重程度采取进一步措施。</div>
				<div>4.平台将不定期更新积分兑换的商品及服务，具体兑换内容以平台展示为准。</div>
				<div>5.积分为平台奖励，平台拥有最终解释权。</div>
			</div>
		</el-dialog>
		<el-dialog class="recordDialog" :visible.sync="dialogRecordViable" append-to-body
			@close="dialogRecordViable = false" @open="integralMoneyList">
			<div slot="title">
				<div class="dislogTitle">
					积分明细
				</div>
			</div>
			<div class="dislogConent">
				<div class="recordList" v-if="recordData.length">
					<div class="recordItem" v-for="(item,index) in recordData" :key="index">
						<div class="recordItemLeft">
							<div class="recordItemTile">
								{{item.content}}
							</div>
							{{item.create_time}}
						</div>
						{{item.price > 0 ? ( '+ ' + item.price) : item.price}}积分
					</div>
				</div>
				<el-empty description="暂无数据" v-else></el-empty>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'MyIntegral',
		data() {
			return {
				catType: '1',
				naviData: [{
					title: '积分商品',
					value: '1',
				}, {
					title: '代金券',
					value: '2',
				}],
				px_price: '0',
				px_buy: '0',
				currentPage: 1,
				total: 0,
				userInfo: {},
				recordData: [],
				integralData: [],
				dialogRecordViable: false,
				dialogIntergralRulesViable: false,
			}
		},
		mounted() {
			this.userDetails()
			this.integralGoodsList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.integralGoodsList()
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeTimeWhere(item) {
				this.catType = item.value
				this.changeSort('0')
			},
			changeSort(type) {
				if (type == '0') {
					this.px_price = 0
					this.px_buy = 0
				} else if (type == '1') {
					this.px_price = this.px_price == 2 ? 1 : 2
					this.px_buy = 0
				} else if (type == '2') {
					this.px_buy = this.px_buy == 2 ? 1 : 2
					this.px_price = 0
				}
				this.integralGoodsList()
			},
			integralGoodsList() {
				this.$api.post('/Goods/integral_goods', {
					p: this.currentPage,
					cat_type: this.catType,
					px_price: this.px_price == 0 ? '' : this.px_price,
					px_buy: this.px_buy == 0 ? '' : this.px_buy,
				}).then(res => {
					if (res.code == 1) {
						this.integralData = res.data.list
						this.total = res.data.count
					}
				}).catch(err => {
					console.log(err);
				})
			},
			integralMoneyList() { //type==1 商品 type==2 券
				this.$api.post('/UserD/integral_money_list', {}).then(res => {
					if (res.code == 1) {
						this.recordData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeToDetails(item) {
				this.$emit('naviToDetails', item)
			},
		}
	}
</script>

<style lang="scss" scoped>
	.intergral-container {
		padding: .28rem .32rem .4rem;
	}

	.title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 600;
		font-size: .16rem;
		color: #333333;

		.rulesBtn {
			font-weight: 400;
			font-size: .12rem;
			color: #333333;
			border: none;
		}
	}

	.intergralBox {
		margin-top: .08rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-bottom: .24rem;
		border-bottom: .01rem solid #CCCCCC;

		.intergralBoxLeft {
			display: flex;
			align-items: center;

			.intergralTotal {
				width: 2.8rem;
				display: flex;
				align-items: center;
				font-weight: 700;
				font-size: .24rem;
				color: #E29358;

				.intergralTotalTitle {
					font-weight: 400;
					font-size: .16rem;
					color: #666666;
				}
			}
		}

		.record {
			width: .76rem;
			height: .32rem;
			background: #EFD8B8;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .12rem;
			color: #252525;
			line-height: .32rem;
			text-align: center;
			cursor: pointer;
		}
	}

	.menuBox {
		margin: .24rem 0 0;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.naviBox {
			display: flex;
			align-items: center;

			.naviItem {
				margin-right: .24rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: .96rem;
				height: .4rem;
				background: #E29358;
				font-size: .16rem;
				text-align: center;
				line-height: .4rem;
				cursor: pointer;
			}

			.active {
				font-weight: 500;
				color: #252525;
				background: #E29358;
			}

			.normal {
				font-weight: 400;
				color: #000000;
				background: rgba(226, 147, 88, .3);
			}
		}

		.menu {
			display: flex;
			align-items: center;

			.menuItem:first-child img {
				width: .08rem;
				height: .04rem;
			}

			.menuItem {
				margin-left: .24rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #161616;
				cursor: pointer;

				img {
					margin-left: .04rem;
					width: .08rem;
					height: .1rem;
				}
			}
		}
	}

	.intergralChangeBox {
		margin-top: .24rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 600;
		font-size: .16rem;
		color: #333333;
	}

	.intergralGoodsList {
		display: flex;
		flex-wrap: wrap;

		.intergralGoods:nth-child(4n) {
			margin-right: 0;
		}

		.intergralGoods {
			margin-top: .24rem;
			margin-right: .22rem;
			display: flex;
			flex-direction: column;
			cursor: pointer;

			.goodsImg {
				width: 2.05rem;
				height: 2.05rem;
				background: #FAEFDD;
				border-radius: .08rem;
				object-fit: cover;
			}

			.goodsTitle {
				margin-top: .16rem;
				font-weight: 700;
				font-size: .18rem;
				color: #000000;
				line-height: .24rem;
			}

			.intergralNum {
				margin-top: .12rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				line-height: .24rem;

				.intergral {
					font-weight: 700;
					font-size: .2rem;
					color: #FF0000;
				}

				.num {
					font-weight: 400;
					font-size: .16rem;
					color: #666666;
				}
			}

			.exchange {
				margin-top: .16rem;
				width: 1.9rem;
				height: .4rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 500;
				font-size: .14rem;
				color: #252525;
				line-height: .4rem;
				text-align: center;
			}
		}
	}

	.recordDialog {
		::v-deep .el-dialog {
			width: 5.4rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}
			
			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}
			
			&__body {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 .24rem .24rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				width: 5.4rem;

				.dislogConent {
					width: 100%;
				}

				.recordList {
					display: flex;
					flex-direction: column;
					max-height: 5rem;
					width: 100%;
					overflow-y: auto;

					.recordItem {
						height: .7rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: .12rem .12rem;
						font-weight: 500;
						font-size: .16rem;
						color: #E29358;
						border-bottom: .01rem solid #CCCCCC;

						.recordItemLeft {
							display: flex;
							flex-direction: column;
							font-weight: 400;
							font-size: .12rem;
							color: #73767C;

							.recordItemTile {
								font-weight: 400;
								font-size: .16rem;
								color: #161616;
							}
						}
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 5.4rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}
			
			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}
			
			&__body {
				padding: 0 .24rem .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
			}
		}
	}
</style>